module.exports = __webpack_public_path__ + "img/tips_icon.35a4438d.png";